angular
  .module('inkfinder')
  .factory('Auth', function Auth(
    $window,
    $auth,
    $rootScope,
    $state,
    $stateParams,
    $cookies,
    $timeout,
    $q,
    Collector,
    USER_ROLES,
    Session,
    AUTH_EVENTS,
    RESPONSE_MESSAGES,
    AlertMessages,
    DEFAULT_STATES,
    Events,
    $uibModal,
    SWITCH_MESSAGE,
    $location,
    _
  ) {
    // Public methods
    Auth.loginInkfinder = loginInkfinder;
    Auth.loginSocial = loginSocial;
    Auth.signupInkFinder = signupInkFinder;
    Auth.isAllowed = isAllowed;
    Auth.getRoles = getRoles;
    Auth.logout = logout;
    Auth.routeAfterAuthentication = routeAfterAuthentication;
    Auth.getSession = getSession;
    Auth.updateSession = updateSession;
    Auth.setState = setState;
    Auth.changeState = changeState;
    Auth.statePicker = statePicker;
    Auth.redirect = {
      url: null
    };

    // Monitor events to make it easier to plan what happens in certain
    // authorization scenarios
    let deregister = $rootScope.$on(AUTH_EVENTS.notAuthenticated, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.authenticationError.message,
        type: 'danger'
      });
      $state.go('login');
    });

    let deregister1 = $rootScope.$on(AUTH_EVENTS.notAuthorized, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.authorizationError.message,
        type: 'danger'
      });
    });

    let deregister2 = $rootScope.$on(AUTH_EVENTS.notFound, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.notFoundError.message,
        type: 'danger'
      });
    });

    $rootScope.$on('$destroy', deregister, deregister1, deregister2);

    /**
   * @name loginInkfinder
   * @description This function takes login credentials (email, password) and
   * passes them to the Satellizer library to retrieve a token from the API.
   * @param {user} credentials The object passing email/password
   * @return {object} Returns an object containing the user and user roles.
   */
    function loginInkfinder(credentials) {
      $window.localStorage.clear();
      return $auth.login(credentials).then(function(response) {
        return Collector.refreshProfile().then(function(collector) {
          return setState(collector).then(function() {
            let roles = getRoles(collector);
            Session.create(response.data.token, roles, collector);
          });
        });
      });
    }

    /**
   * @description Log in using a third party account. This services is provided
   * by Sattellizer
   * @param {unknown} provider Unknown
   * @return {object} Returns the collector object
     */
    function loginSocial(provider) {
      $window.localStorage.clear();
      return $auth.authenticate(provider).then(function(response) {
        return Collector.refreshProfile().then(function(collector) {
          return setState(collector).then(function() {
            let roles = getRoles(collector);
            Session.create(response.data.token, roles, collector);
          });
        });
      });
    }

    /**
   * @description The Ink Finder signup function
   * @param {obejct} credentials The credentials object from the signup form
   * @return {object} Returns the collector object.
   */
    function signupInkFinder(credentials) {
      $window.localStorage.clear();
      return $auth.signup(credentials).then(function(response) {
        $auth.setToken(response.data.token); // Set the token for Satellizer
        let newCollector = {
          email: response.config.data.email,
          accepted_TOS_Privacy: true
        };
        return Collector.updateProfile(newCollector).then(function(collector) {
          let roles = getRoles(collector);
          Session.create(response.data.token, roles, collector);
        });
      });
    }

    /**
   * @name getSession
   * @description A function to get the session for the collector when a valid
   * token is present.
   * @return {object} Returns the session object.
   */
    function getSession() {
      return $q(function(resolve, reject) {
        if (_.isUndefined(Session.collector)) {
          return Collector.refreshProfile().then(function(collector) {
            let token = $auth.getToken;
            let roles = getRoles(collector);
            Session.create(token, roles, collector);
            return setState(collector).then(function() {
              Events.loggedIn = true;
              resolve(Session);
            });
          });
        }
        resolve(Session);
      });
    }

    /**
   * @name setState
   * @description Function to set the active state of the user.
   * @param {object} collector The collector of the logged in user.
   * @return {promise} Returns the statePicker to choose your active state
   * or the active state set when only one selling state exists.
   */
    function setState(collector) {
      return $q(function(resolve, reject) {
        let count = 1;
        const states = [];
        states.buying = [];
        states.selling = [];
        // By default, add a collector state
        let collectorState = {
          mode: 'buying',
          role: 'collector',
          switchMessage: SWITCH_MESSAGE.buying,
          associations: collector.associations.collectors.confirmed,
          id: count
        };
        states.buying.push(collectorState);
        count++;
        // Add an artist state if the collector is also an artist
        if (collector.associations.artists.confirmed.length > 0) {
            for (
              let i = 0;
              i < collector.associations.artists.confirmed.length;
              i++
            ) {
              let artistState = {
                mode: 'selling',
                role: 'artist',
                switchMessage: SWITCH_MESSAGE.selling,
                association: collector.associations.artists.confirmed[i],
                id: count
              };
              states.selling.push(artistState);
              count++;
            }
          }
        // Add an operator state if the collector is an operator
        if (collector.operator !== null) {
          // Check for approved associations
          if (collector.associations.operators.confirmed.length > 0) {
            for (
              let i = 0;
              i < collector.associations.operators.confirmed.length;
              i++
            ) {
              let operatorState = {
                mode: 'selling',
                role: 'operator',
                switchMessage: SWITCH_MESSAGE.selling,
                association: collector.associations.operators.confirmed[i],
                id: count
              };
              states.selling.push(operatorState);
              count++;
            }
          }
        }
        // Send the state to the Session
        Session.defineStates(states);
        // If the state was stored in a cookie, then resolve and set the active
        // state to the state found in the cookie. Otherwise, if there are more
        // than one selling state, allow the user to pick the one they want to
        // use initially. Otherwise, choose the selling state as the active
        // state. If no selling state exists, choose the buying state as the
        // active state.
        let _state = $cookies.getObject('inkfinder');
        let allStates = states.buying.concat(states.selling);

        if (!_.isUndefined(_state)) {
          // If only one operator state exists
          if (_state.association && _state.association.id) {
            _state.association = _.find(allStates, {
              association: {id: _state.association.id}
            }).association;
          }

          // If multiple artists states exists
          if (_state.associations && _state.associations.length) {
            let updatedAssociations = _.map(
              _state.associations,
              obj =>
                _.find(collector.associations.all, o => o.id === obj.id) || obj
            );
            _state.associations = updatedAssociations;
          }

          // Push a fresh copy of the state to the cookie
          $cookies.putObject('inkfinder', _state);
          resolve(Session.setActiveState(_state));
        } else if (states.selling.length > 1) {
          let logOutPossible = true;
          statePicker(states, logOutPossible).then(function(activeState) {
            $cookies.putObject('inkfinder', activeState);
            resolve(Session.setActiveState(activeState));
          });
        } else if (states.selling.length === 1) {
          $cookies.putObject('inkfinder', states.selling[0]);
          resolve(Session.setActiveState(states.selling[0]));
        } else {
          $cookies.putObject('inkfinder', states.buying[0]);
          resolve(Session.setActiveState(states.buying[0]));
        }
      });
    }

    /**
   * @name statePicker
   * @description Function to fire off a modal when there is more than one
   * selling mode state to allow the user to choose which profile to sell as.
   * @param {array} states The possible states for the logged in user.
   * @param {boolean} logOutPossible Boolean to determine if we can safely
   * dismiss the modal by clicking the escape key or outside the modal window.
   * @return {array} states The resolve function returns the states to the
   * modal controller.
   * @return {object} activeState Resolves the state chosen by the user.
   */
    function statePicker(states, logOutPossible) {
      return $q(function(resolve, reject) {
        let noClick = true;
        if (logOutPossible === true) {
          noClick = 'static';
        }
        let modalInstance = $uibModal.open({
          template: require('./state-picker/state-picker.template.html'),
          animation: true,
          controller: 'StatePickerController',
          bindToController: true,
          backdrop: noClick,
          keyboard: !logOutPossible,
          controllerAs: '$ctrl',
          resolve: {
            states: function() {
              return states;
            },
            logOutPossible: function() {
              return logOutPossible;
            }
          }
        });
        modalInstance.result.then(
          function(activeState) {
            resolve(activeState);
          },
          function(error) {
            reject(error);
          }
        );
      });
    }

    /**
   * @name changeState
   * @description This function is called from ui switchers when changing the
   * mode of the app.
   * @return {unknown} Unknown
   */
    function changeState() {
      return $q(function(resolve, reject) {
        if (Session.activeState.mode === 'selling') {
          const state = {
            mode: 'buying',
            role: 'collector',
            switchMessage: SWITCH_MESSAGE.buying,
            id: 1
          };
          $rootScope.$broadcast('clear-data');
          Session.setActiveState(state);
          $cookies.putObject('inkfinder', state);
          resolve($state.go(DEFAULT_STATES.buying));
        } else if (Session.states.selling.length > 1) {
          let logOutPossible = false;
          statePicker(Session.states, logOutPossible).then(function(
            activeState
          ) {
            $rootScope.$broadcast('clear-data');
            Session.setActiveState(activeState);
            $cookies.putObject('inkfinder', activeState);
            if (activeState.role === 'operator') {
              resolve($state.go(DEFAULT_STATES.operator));
            } else {
              resolve($state.go(DEFAULT_STATES.artist));
            }
          });
        } else {
          $rootScope.$broadcast('clear-data');
          Session.setActiveState(Session.states.selling[0]);
          $cookies.putObject('inkfinder', Session.states.selling[0]);
          if (Session.states.selling[0].role === 'operator') {
            resolve($state.go(DEFAULT_STATES.operator));
          } else {
            resolve($state.go(DEFAULT_STATES.artist));
          }
        }
      });
    }

    /**
   * @name updateSession
   * @description A function to update the session for the collector when the
   * collector object is updated.
   * @return {object} Return the Session service.
   */
    function updateSession() {
      return Collector.refreshProfile().then(function(collector) {
        let token = $auth.getToken();
        let roles = getRoles(collector);
        return Session.create(token, roles, collector);
      });
    }

    /**
   * @description
   * The authorize function sets roles for the logged in user based on their
   * associations and extended role objects inside the collector object.
   * @param {object} collector The collector object containing extended objects
   * for artist and operator
   * @return {array} roles Returns an array of roles.
   */
    function getRoles(collector) {
      let roles = [];
      if (collector.operator !== null) {
        roles.push(USER_ROLES.operator);
      }
      if (collector.artist !== null) {
        roles.push(USER_ROLES.artist);
      }
      roles.push(USER_ROLES.collector);
      return roles;
    }

    /**
   * @name isAllowed
   * @description Determines if the collector has the roles needed to view the
   * state. If the collector has the authorized roles, then we check to see if
   * the collector is authenticated through Satellizer.
   * @param {array} authorizedRoles The array of authorized roles originating
   * from specific states
   * @return {boolean} Returns a boolean value.
   */
    function isAllowed(authorizedRoles) {
      let authenticated = $auth.isAuthenticated();
      let roleMatch = false;
      let session = Session;
      if (_.intersection(authorizedRoles, session.roles).length > 0) {
        roleMatch = true;
      }
      return authenticated && roleMatch;
    }

    /**
   * @name routeAfterAuthentication
   * @description Function called after a successful login.
   * TODO Integrate this with cookies to remember the selected path
   */
    function routeAfterAuthentication() {
      if (Auth.redirect.url !== null) {
        $location.path(Auth.redirect.url);
      } else if (Session.activeState.role === 'artist') {
        $state.go(DEFAULT_STATES.artist);
      } else if (Session.activeState.role === 'operator') {
        $state.go(DEFAULT_STATES.operator);
      } else {
        $state.go(DEFAULT_STATES.buying);
      }
    }

    /**
   * @name logout
   * @description Logout of Satellizer. Destroy Session data. Broadcast
   * 'clear-data' to cleanup factories. And go to the login state
   * @param {string} route The route to go to after logout
   */
    function logout() {
      $state.go('logout');
      $rootScope.$broadcast('clear-data');
      Events.loggedIn = false;
      Session.destroy(); // Remove roles, token, and collector
      $cookies.remove('inkfinder');
      $auth.logout(); // Satellizer logout
    }
    return Auth;
  });



// WEBPACK FOOTER //
// ./components/auth/auth.service.js